// TotalesXL - Sprint 44 Fase 3 Vista 4.
// Card de totales de documento comercial (cotizacion / venta).
// Muestra subtotal + IVA + total con separador de miles tokenizado,
// variante "precio incluye IVA" (label cambia). Reutilizable por
// ambos docTypes.
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../design/motion';
import { fmtMoney } from '../../utils/money';

const CSS_ID = 'xl-totales-css';
const CSS = `
.xl-totales-wrap { display: flex; justify-content: flex-end }

.xl-totales {
  width: 100%;
  max-width: 360px;
  background: var(--xl-color-surface);
  border: 1px solid var(--xl-color-border);
  border-radius: var(--xl-radius-lg);
  padding: 16px 18px;
  box-shadow: var(--xl-shadow-sm);
  font-family: var(--xl-font-sans);
  color: var(--xl-color-text);
}
.xl-totales__row {
  display: flex; align-items: center; justify-content: space-between;
  padding: 4px 0;
}
.xl-totales__label {
  font-size: 13px;
  color: var(--xl-color-text-secondary);
}
.xl-totales__value {
  font-family: var(--xl-font-mono);
  font-size: 13px;
  color: var(--xl-color-text);
}
.xl-totales__sep {
  margin: 8px 0 6px;
  border: 0;
  border-top: 1px solid var(--xl-color-border);
}
.xl-totales__grand {
  display: flex; align-items: center; justify-content: space-between;
  padding: 6px 0 0;
}
.xl-totales__grand-label {
  font-size: 14px;
  font-weight: 600;
  color: var(--xl-color-text);
}
.xl-totales__grand-value {
  font-family: var(--xl-font-mono);
  font-size: 16px;
  font-weight: 600;
  color: var(--xl-color-text);
}
.xl-totales__note {
  margin-top: 6px;
  font-size: 11px;
  color: var(--xl-color-text-muted);
  font-style: italic;
}
`;

export default function TotalesXL({ doc, moneda = 'COP' }) {
  useEffect(() => { ensureKeyframes(); injectCSS(CSS_ID, CSS); }, []);

  if (!doc) return null;
  const incluye = !!doc.precio_incluye_iva;
  const subtotal = doc.subtotal;
  const iva = doc.iva_total;
  const total = doc.total;
  const ivaLabel = incluye ? 'IVA (incluido)' : 'IVA';

  return (
    <div className="xl-totales-wrap">
      <div className="xl-totales" role="group" aria-label="Totales del documento">
        <div className="xl-totales__row">
          <span className="xl-totales__label">Subtotal</span>
          <span className="xl-totales__value">
            {fmtMoney(subtotal, moneda)}
          </span>
        </div>
        <div className="xl-totales__row">
          <span className="xl-totales__label">{ivaLabel}</span>
          <span className="xl-totales__value">
            {fmtMoney(iva, moneda)}
          </span>
        </div>
        <hr className="xl-totales__sep" />
        <div className="xl-totales__grand">
          <span className="xl-totales__grand-label">TOTAL</span>
          <span className="xl-totales__grand-value">
            {fmtMoney(total, moneda)}
          </span>
        </div>
        {incluye && (
          <div className="xl-totales__note">
            Los precios de linea ya incluyen el IVA calculado.
          </div>
        )}
      </div>
    </div>
  );
}
